import './dropdown';



// WEBPACK FOOTER //
// ./client/src/core/components/search/index.js